import script from "./SubmissionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmissionPage.vue?vue&type=script&setup=true&lang=js"

import "./SubmissionPage.vue?vue&type=style&index=0&id=a7443f14&lang=css"

const __exports__ = script;

export default __exports__